<script lang="ts" setup>
import { PropType, computed } from 'vue'

/* Types */
import { ConstructorPizza } from '@/types/api/api-v3/halves'

/* Assets */
import productNoImage from '@/assets/images/halves-no-image.webp'

const props = defineProps({
  constructorPizza: {
    type: Object as PropType<ConstructorPizza>,
    required: true,
  },
})

const leftHalveImage = computed(() => {
  const { leftHalve } = props.constructorPizza

  return leftHalve ? leftHalve.image : productNoImage
})

const rightHalveImage = computed(() => {
  const { rightHalve } = props.constructorPizza

  return rightHalve ? rightHalve.image : productNoImage
})

const emits = defineEmits(['clickImage'])
</script>

<template>
  <div class="constructor">
    <div
      class="constructor__left-halve"
      :style="{ 'background-image': `url(${leftHalveImage})` }"
      @click="emits('clickImage')"
    />
    <div
      class="constructor__right-halve"
      :style="{ 'background-image': `url(${rightHalveImage})` }"
      @click="emits('clickImage')"
    />
  </div>
</template>

<style lang="scss" scoped>
.constructor {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 410px;
  height: 256px;
  margin-bottom: 40px;

  &__left-halve,
  &__right-halve {
    width: 205px;
    height: inherit;
    background-origin: border-box;
    background-size: cover;
    opacity: 1;
    transition: 0.17s ease-in-out;
  }

  &__left-halve {
    background-position: left center;
  }

  &__right-halve {
    background-position: right center;
  }
}
</style>
